export default __webpack_public_path__ + "media/titles/title_2_locale_it-b9339c7c.png";